<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="创建人"
                        prop="admin_id">
            <remote-select class="width-max"
                           v-model="search.admin_id"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="name"
                           placeholder="请输入账号名搜索"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="search.status"
                       class="width-max"
                       clearable
                       placeholder="请选择状态">
              <el-option v-for="(label, value) in statusMap"
                         :key="value"
                         :label="label"
                         :value="value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link to="/audit-intern/attendance-notify-cfg/create">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">新增提醒通知
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border>
        <template v-for="attr of tableColumns">
          <el-table-column v-bind="attr"></el-table-column>
        </template>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="op-buttons">
              <el-button type="warning"
                         @click="doEdit(scope.row)"
                         size="mini">编辑
              </el-button>
              <el-button type="danger"
                         size="mini"
                         @click="doInactive(scope.row)"
                         v-if="scope.row.status === 1">禁用
              </el-button>
              <el-button type="success"
                         size="mini"
                         @click="doActive(scope.row)"
                         v-if="scope.row.status === 2">启用
              </el-button>
              <router-link :to="`/audit-intern/attendance-notify-history/${scope.row.id}/table`">
                <el-button type="primary"
                           size="mini">通知发送记录
                </el-button>
              </router-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import RemoteSelect from '@core/components/RemoteSelect.vue'

export default {
  components: {RemoteSelect},
  mixins: [table],
  data () {
    return {
      search: {
        admin_id: null,
        status: null,
      },
      searchFieldType: {},
      tableColumns: [
        {prop: 'id', label: 'ID', width: '100'},
        {prop: 'title', label: '标题', minWidth: '90'},
        {prop: 'content', label: '通知内容', width: '300', showOverflowTooltip: true},
        {prop: 'trigger_at', label: '提醒时间', minWidth: '90'},
        {prop: 'status', label: '状态', width: '90', formatter: row => _.get(this.statusMap, row.status, row.status)},
        {prop: 'admin_info', label: '创建人', minWidth: '80'},
        {prop: 'created_at', label: '创建时间', width: '180'},
      ],
      statusMap: {
        1: '启用',
        2: '禁用',
      },
    }
  },
  computed: {},
  created () {},
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    getTableData (params) {
      return request.common('queryAttendanceNotifyCfgTableApi', params)
    },
    isPassedTriggerTime (row) {
      const triggerTime = new Date(row.trigger_at.replace(' ', 'T')).getTime()
      return triggerTime <= Date.now()
    },
    doEdit (row) {
      if (this.isPassedTriggerTime(row)) {
        this.$message.error('提醒时间已过，不支持编辑')
        return
      }
      this.$router.push(`/audit-intern/attendance-notify-cfg/update/${row.id}`)
    },
    async doActive (row) {
      if (this.isPassedTriggerTime(row)) {
        this.$message.error('提醒时间已过，不支持重新启用，请创建新的提醒通知')
        return
      }
      await request.common('activeAttendanceNotifyCfgApi', {id: row.id})
      this.onRefresh()
    },
    async doInactive (row) {
      if (this.isPassedTriggerTime(row)) {
        await this.$confirm('提醒时间已过，禁用后不再支持重新启用，是否要禁用此提醒通知?', '警告', {type: 'warning'})
      } else {
        await this.$confirm('是否要禁用此提醒通知?', '提示', {type: 'warning'})
      }
      await request.common('inactiveAttendanceNotifyCfgApi', {id: row.id})
      this.onRefresh()
    },
  },
}
</script>
<style lang="scss">
</style>
<style lang="scss"
       scoped>
/* 操作列按钮纵向固定排列，v-if 切换时不会因 inline 流动导致位置左右移动 */
.op-buttons {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;

  /* 覆盖 element-ui 全局 .el-button + .el-button 的 10px 左间距 */
  .el-button + .el-button {
    margin-left: 0;
  }
}
</style>
<style lang="scss"
       module>
</style>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/attend-notify/InternAttendanceNotifyCfgTable.vue